import type { AxiosRequestConfig } from 'axios';
import type {
  IdentifyRuleFullResponse,
  IdentifyRuleRequest,
  IdentifyRuleResponse,
  IdentifyRuleResponseWithParent,
} from '@/entities/srm/ci';
import { srmInstance } from '@/shared/api/api-instances/srm/api-instance';

const URL = '/identify_rules';

export class IdentifyRulesApi {
  static getParentValues(cit_id: string, options: AxiosRequestConfig = {}) {
    return srmInstance.get<IdentifyRuleFullResponse>(
      `${URL}/${cit_id}/get_parent`,
      options,
    );
  }

  static makeLikeParent(cit_id: string, options: AxiosRequestConfig = {}) {
    return srmInstance.put<IdentifyRuleResponse>(
      `${URL}/${cit_id}/make_as_parent`,
      null,
      options,
    );
  }

  static getCitItemIdentifyRules(
    citId: string,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.get<IdentifyRuleResponse>(`${URL}/${citId}`, options);
  }

  static getCitItemIdentifyRulesWithParent(
    citId: string,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.get<IdentifyRuleResponseWithParent>(
      `${URL}/${citId}/with_parent`,
      options,
    );
  }

  // Устаревшее
  static updateCitItemIdentifyRules(
    citId: string,
    payload: IdentifyRuleRequest,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.put<IdentifyRuleResponse>(
      `${URL}/${citId}`,
      payload,
      options,
    );
  }

  static deleteCitItemIdentifyRules(
    citId: string,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.delete(`${URL}/${citId}`, options);
  }
}